<div class="cardsContainer">
    <div class="cardsColumns">
        <div class="cardsColumn">
            <lib-generic-card
                [title]="'Main Info'"
                [highlight]="true"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityMainInfo]"
                (valueChange)="emitValueChanged()"
                #mainInfoCard
            >
            </lib-generic-card>

            <lib-generic-card [title]="'Values'" [highlight]="true" (valueChange)="emitValueChanged()">
                <app-opportunities-values-grid
                    [opportunity]="opportunity()"
                    [actualValue]="actualValue()"
                    [termValue]="termValue()"
                    [isReadOnly]="isReadOnly()"
                    [isCreateEstimate]="isCreateEstimate()"
                    [baseEstimateExternal]="baseEstimateExternal()"
                    (valueChange)="emitValueChanged()"
                    #valuesGrid
                ></app-opportunities-values-grid>
            </lib-generic-card>

            <lib-generic-card
                [title]="'Organization'"
                [highlight]="true"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityOrganization]"
                [hasArchivedItems]="organizationHasArchived"
                (valueChange)="emitValueChanged()"
                #organizationCard
            >
            </lib-generic-card>
        </div>
        <div class="cardsColumn">
            <lib-generic-card
                [title]="'Opportunity Details'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityDetails]"
                (valueChange)="emitValueChanged()"
                [hasArchivedItems]="productTypeHasArchived || usersHasArchived"
                #detailsCard
            >
            </lib-generic-card>

            <lib-generic-card
                [title]="'Bid Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityBidInfo]"
                [hasArchivedItems]="bidInfoHasArchived"
                (valueChange)="emitValueChanged()"
                #bidInfoCard
            >
            </lib-generic-card>

            <lib-generic-card
                [title]="'Main Building'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityBuilding]"
                (valueChange)="emitValueChanged()"
                [hasArchivedItems]="buildingHasArchived"
                #buildingCard
            >
            </lib-generic-card>
        </div>
    </div>
    <div class="cardsColumn">
        <lib-generic-card
            [title]="'Customer'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.OpportunityCustomer]"
            [hasArchivedItems]="customerHasArchived"
            (valueChange)="emitValueChanged()"
        >
        </lib-generic-card>

        <lib-generic-card
            [title]="'Contracting Team'"
            [factory]="factory"
            [configItems]="cardsConfig[entityCardSection.OpportunityContractingTeam]"
            [hasArchivedItems]="contractingTeamHasArchived"
            (valueChange)="emitValueChanged()"
        >
        </lib-generic-card>

        @if (
            cardsConfig[entityCardSection.OpportunityCustomInfo] &&
            cardsConfig[entityCardSection.OpportunityCustomInfo].length
        ) {
            <lib-generic-card
                [title]="'Custom Info'"
                [factory]="factory"
                [configItems]="cardsConfig[entityCardSection.OpportunityCustomInfo]"
                (valueChange)="emitValueChanged()"
                #customInfoCard
            >
            </lib-generic-card>
        }
    </div>
</div>
